import type { TeamsApi } from "@/v2/api/metadata/teams";
import { createFeedConfigDialogApi } from "@/v2/kits/feed-config";
import { teamId } from "../../shared";

export function createTeamFeedConfigApi(teamsApi: TeamsApi) {
  return createFeedConfigDialogApi(({ values }) => teamId(values), {
    getFeedTypeMappings: teamsApi.getFeedTypeMappings.bind(teamsApi),
    getFeedInstanceMappings: teamsApi.getFeedInstanceMappings.bind(teamsApi),
    updateEntity: async (entityId, payload) => {
      await teamsApi.update(entityId, payload);
    },
  });
}
